export default __webpack_public_path__ + "static/media/custModeLCloseIcon.ed404d59.svg";